"use client";

import {
  ErrorComponent,
  usePathnameLanguage,
} from "@global-rentacar-frontend/shared/components";
import { useEffect } from "react";
import { useTranslation } from "../../i18n/client";
import { getTranslationString } from "@global-rentacar-frontend/translation";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { currentLanguage } = usePathnameLanguage();

  useEffect(() => {
    console.error(error);
  }, [error]);

  const { t: getErrorPageConditions } = useTranslation(
    currentLanguage,
    "Error_Page"
  );

  const errorMessageText = getTranslationString({
    conditions: getErrorPageConditions(
      "Error_Page.General_Error.Error_Message"
    ),
    defaultValue: "",
  });
  const actionMessageText = getTranslationString({
    conditions: getErrorPageConditions(
      "Error_Page.General_Error.Action_Message"
    ),
    defaultValue: "",
  });
  const navigationText = getTranslationString({
    conditions: getErrorPageConditions("Error_Page.General_Error.Navigation"),
    defaultValue: "",
  });

  return (
    <div data-testid="mypage-error-boundary" className="mt-10">
      <ErrorComponent
        currentLanguage={currentLanguage}
        isFetching={false}
        navigation={navigationText}
        actionMessage={actionMessageText}
        errorMessage={errorMessageText}
      />
    </div>
  );
}
